export default __webpack_public_path__ + "static/media/up-arrow.12cd8742.svg";